export function getActiveStatus(id) {
    return ['active', 'pending', 'deleted', 'suspended', 'expired', 'deactivated', 'delayed'][
        id - 1
    ];
}
